import React from "react";
//home page can be changed for any page
import CenterPanelBookingOnlyCustomerProfile from "./centerPanel";
import BottomPanelBookingOnlyCustomerProfile from "./bottomPanel";

export default function BookingOnlyCustomerProfileContent() {
  return (
    <div>
      <CenterPanelBookingOnlyCustomerProfile />
      <BottomPanelBookingOnlyCustomerProfile />
    </div>
  );
}
